export default __webpack_public_path__ + "images/eb608b760766cc8051afb4d38910a3fa-marc_bormann.png";